/* Custom Fireside — slim sticky header on phones (Oct 2026).
   Adds .cf-header--compact to the sticky header once you scroll down
   (styles in assets/cf-mobile.css), and removes it near the top of the page.
   The header is sticky and takes up space in the page, so when it shrinks we
   add the difference as margin below it; that keeps the page from jumping. */
(function () {
  var header = document.querySelector('.section-header');
  if (!header) return;

  var phone = window.matchMedia('(max-width: 749px)');
  var compact = false;
  var ticking = false;
  var SHRINK_AT = 140; // px scrolled before the header shrinks
  var GROW_AT = 40; // px from the top before it grows back

  function setCompact(on) {
    if (on === compact) return;
    if (on) {
      var full = header.offsetHeight;
      header.classList.add('cf-header--compact');
      var small = header.offsetHeight;
      header.style.marginBottom = Math.max(full - small, 0) + 'px';
    } else {
      header.classList.remove('cf-header--compact');
      header.style.marginBottom = '';
    }
    compact = on;
  }

  function check() {
    ticking = false;
    if (!phone.matches) {
      setCompact(false);
      return;
    }
    var y = window.scrollY || window.pageYOffset;
    if (!compact && y > SHRINK_AT) setCompact(true);
    else if (compact && y < GROW_AT) setCompact(false);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(check);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (phone.addEventListener) phone.addEventListener('change', check);
  check();
})();
